import { render, staticRenderFns } from "./deleteAccount.vue?vue&type=template&id=33aa70e0&scoped=true"
import script from "./deleteAccount.vue?vue&type=script&lang=js"
export * from "./deleteAccount.vue?vue&type=script&lang=js"
import style0 from "./deleteAccount.vue?vue&type=style&index=0&id=33aa70e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aa70e0",
  null
  
)

export default component.exports